import { api } from 'common';

import { PatientDataStoreFormFields } from './FormFields';
import { PatientDataStoreDocumentationMarkdown } from './documentation';
import { ProducedType } from '../../../types';
import { type BlockConfigProps } from '../../types';

const PatientDataStoreEndpoint = api.FlowDefinition.PatientDataStore.PatientDataStoreEndpoint;
type PatientDataStoreEndpoint = api.FlowDefinition.PatientDataStore.PatientDataStoreEndpoint;
type PatientDataStoreBlockConfig = api.FlowDefinition.PatientDataStore.PatientDataStoreBlockConfig;

export const PatientDataStoreConfig: BlockConfigProps<PatientDataStoreBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'SmartFetchFromChart',
  defaultConfig: {
    endpoint: PatientDataStoreEndpoint.DocumentMetadata,
    patient: {
      sourceBlockName: '',
    },
    returnType: ProducedType.PdsDocumentMetadata,
  },
  configFields: {
    schema: api.FlowDefinition.PatientDataStore.PatientDataStoreConfigSchema,
    FormFields: PatientDataStoreFormFields,
  },
  documentationMarkdown: PatientDataStoreDocumentationMarkdown,
};
